export const UserRole = {
  User: 0,
  dashboard: 'ecp',
};
